import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet-async';

export class PageSEO extends Component {
  getTitle() {
    const { title } = this.props;

    return title;
  }

  getLink() {
    const link = [];

    const { canonicalUrl } = this.props;

    // Canonical Url (TODO: Prefix with domain)
    link.push({
      rel: 'canonical',
      href: canonicalUrl
    });

    return link;
  }

  getMeta() {
    const meta = [];

    const {
      canonicalUrl,
      description,
      facebookDescription,
      facebookImage,
      facebookTitle,
      twitterDescription,
      twitterImage,
      twitterTitle
    } = this.props;

    // Description
    if (description) {
      meta.push({
        name: 'description',
        content: description
      });
    }

    // Static Facebook Values
    meta.push(
      {
        property: 'og:type',
        content: 'website'
      },
      {
        property: 'og:site_name',
        content: 'LodgeLink'
      }
    );

    // Facebook Description
    if (facebookDescription) {
      meta.push({
        property: 'og:description',
        content: facebookDescription
      });
    }

    // Facebook Image (TODO: Prefix with domain)
    if (facebookImage) {
      meta.push({
        property: 'og:image',
        content: facebookImage
      });
    }

    // Facebook Title
    if (facebookTitle) {
      meta.push({
        property: 'og:title',
        content: facebookTitle
      });
    }

    // Facebook Url (TODO: Prefix with domain)
    if (canonicalUrl) {
      meta.push({
        property: 'og:url',
        content: canonicalUrl
      });
    }

    // Static Twitter Values
    meta.push(
      {
        name: 'twitter:card',
        content: 'summary_large_image'
      },
      {
        name: 'twitter:site',
        content: '@LodgeLink'
      },
      {
        name: 'twitter:creator',
        content: '@LodgeLink'
      }
    );

    // Twitter Description
    if (twitterDescription) {
      meta.push({
        name: 'twitter:description',
        content: twitterDescription
      });
    }

    // Twitter Image (TODO: Prefix with domain)
    if (twitterImage) {
      meta.push({
        name: 'twitter:image',
        content: twitterImage
      });
    }

    // Twitter Title
    if (twitterTitle) {
      meta.push({
        name: 'twitter:title',
        content: twitterTitle
      });
    }

    return meta;
  }

  render() {
    return <Helmet title={this.getTitle()} meta={this.getMeta()} link={this.getLink()} />;
  }
}

PageSEO.propTypes = {
  canonicalUrl: PropTypes.string,
  description: PropTypes.string,
  facebookDescription: PropTypes.string,
  facebookImage: PropTypes.string,
  facebookTitle: PropTypes.string,
  title: PropTypes.string,
  twitterDescription: PropTypes.string,
  twitterImage: PropTypes.string,
  twitterTitle: PropTypes.string
};

PageSEO.defaultProps = {
  canonicalUrl: null,
  description: null,
  facebookDescription: null,
  facebookImage: null,
  facebookTitle: null,
  title: null,
  twitterDescription: null,
  twitterImage: null,
  twitterTitle: null
};

// Add default export to maintain backward compatibility
export default PageSEO;
